import {createRouter, createWebHistory} from 'vue-router'
import commonRoutes from './modules/commonRoutes'
import authRoutes from './modules/authRoutes'
import userRoutes from './modules/userRoutes'
import financeRoutes from './modules/financeRoutes'
import feeRuleRoutes from './modules/feeRuleRoutes'
import inboundRoutes from './modules/inboundRoutes'
import inventoryRoutes from './modules/inventoryRoutes'
import outboundRoutes from './modules/outboundRoutes'
import announcementLogRoutes from './modules/announcementLogRoutes'
import memberPromotionRoutes from './modules/memberPromotionRoutes'
import publicRoutes from './modules/publicRoutes'

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/',

        component: function () {
            return import('../components/home/Home.vue')
        },
        children: [
            ...commonRoutes,
            ...authRoutes,
            ...userRoutes,
            ...financeRoutes,
            ...feeRuleRoutes,
            ...inboundRoutes,
            ...inventoryRoutes,
            ...outboundRoutes,
            ...announcementLogRoutes,
            ...memberPromotionRoutes
        ]
    },
    ...publicRoutes
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
